import styled from 'styled-components';
import { IC_DOCTOR_BG, IC_EPHARMACY_BG, IC_HOMECARE_BG } from '../../Assets/images';

export const CommonHomeStyled = styled.div`
  .home-page-banner {
    .container {
      padding: 0;
    }
  }
  .specialtySlider {
    width: 100%;

  .slick-arrow {
      top: 35px;
      transform: translate(0, 0);
    }
  }

  .redirectionHotLinks {
    width: 100%;
    a {
      color: inherit;
      text-decoration: none;
    }

    .container {
      display: flex;
      justify-content: center;

      .btn {
        margin: 0 9px 24px 9px;
        padding: 16px;
        justify-content: flex-start;

        .left {
          margin-right: 18px;
        }
      }

      .btnDoctor {
        .btn {
          border-color: ${(props) => props?.theme?.blue?.light};
          background-image: url(${IC_DOCTOR_BG.src}),
            linear-gradient(57.07deg, ${(props) => props?.theme?.blue?.light} 36.1%, #18c8ff 100%);
          transition: opacity 0.4s ease;
          background-position: center right;
          background-repeat: no-repeat;
          border: 0;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .btnEPharmacy {
        .btn {
          border-color: ${(props) => props?.theme?.green?.light};
          border: 0;
          transition: opacity 0.4s ease;
          background-position: center right;
          background-repeat: no-repeat;
          background-image: url(${IC_EPHARMACY_BG.src}),
            linear-gradient(57.07deg, ${(props) => props?.theme?.green?.light} 36.1%, #c4e171 100%);
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
  .mobile-book-appoint-spacing {
    .container {
      padding-bottom: 0;
    }
  }
  .popular_categories_wrapper {
    .ePharmacy {
      .slick-slide {
        width: calc(4%) !important;
      }
    }
    .popular_categories_wrapper {
      .ePharmacy {
        .slick-slide {
          width: calc(4%) !important;
        }
      }
      .link {
        margin: 15px 0;
      }
    }
    @media (max-width: 991px) {
      .specialtySlider {
        .slick-arrow {
          &.slick-next {
            right: 0px;
          }
          &.slick-prev {
            left: 0px;
          }
        }
      }
    }

    @media (max-width: 820px) {
      .pageContent {
        padding-top: 175px;
      }
      
      .specialtyContainer {
        &.container {
          padding: 16px 0;
        }
      }
      .brand-section {
        .ePharmacy {
          .slick-list {
            margin: 0 0 0 -8px;
          }
        }
      }
      .popular_categories_wrapper {
        .ePharmacy {
          .slick-list {
            margin: 0 0 0 -8px;
          }
        }
      }
    }

  @media (max-width: 575px) {
    .doctorsBySpecialty {
      padding-left: 0;
      padding-right: 0;
    }
    .mobile-common-top-specialty {
      .doctorsBySpecialty {
        .specialtyContainer {
          .titleBar {
            padding: 0px 16px;
          }
        }
      }
    }
    .specialtyContainer {
      .slick-arrow {
        &.slick-prev {
          top: 50%;
          left: 0;
        }
        &.slick-next {
          top: 50%;
          right: 0;
        }
      }

      padding: 0;
      .slick-initialized .slick-slide {
        width: auto !important;
      }
    }
    .popular_categories_wrapper {
      .slick-slider {
        .slick-slide {
          width: 30vw !important;
        }
      }
    }
  }

    @media (max-width: 480px) {
      .home-page-banner {
        .slick-slide {
          width: 100%;
          margin: 0 0px 0 0;
        }
      }
      .pageContent {
        padding-top: 130px;
      }
  }

  @media (max-width: 380px) {
    .pageContent {
      padding-top: 120px;
    }
  }
`;
